module.exports = __webpack_public_path__ + "img/JieChen.1d53ec9e.png";